<div class="address-search">
    <div class="search-box">
        <mat-icon class="search-icon">search</mat-icon>

        <input id="address" type="text" [value]="address" (input)="onAddressChange($event)"
            (keydown.enter)="searchAddress()" autocomplete="off" placeholder="Buscar una dirección" />

        <button *ngIf="address" type="button" class="clear-button" (click)="clearAddress()"
            aria-label="Limpiar búsqueda">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <ul *ngIf="suggestions.length" class="suggestions">
        <li *ngFor="let suggestion of suggestions"> <button type="button" class="suggestion"
                (click)="selectSuggestion(suggestion)"> <span class="suggestion-icon"> <mat-icon>location_on</mat-icon>
                </span> <span class="suggestion-content"> <span class="suggestion-title"> {{ suggestion.title }} </span>
                    <span class="suggestion-description"> {{ getSuggestionDescription(suggestion) }} </span> </span>
            </button> </li>
    </ul>
</div>